<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title="Add Customer Details"
      :ref="modalId"
      :id="modalId"
      @hide="handleOnHideModal"
    >
      <div class="col-12 h-100">
        <div class="pos-mobile-number">
          <div>
            <div class="row">
              <div class="col-12 mb-4">
                <div class="country-code">
                  <div class="d-flex align-items-center">
                    <!--variant="dropdown-curve-lg bg-theme-light"-->
                    <b-dropdown
                      :text="getCustMobCode ? getCustMobCode : 'Code'"
                      variant="dropdown-curve"
                      class="w-50 text-center mr-3"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in Countries"
                        :key="countryIndex"
                        v-on:click="onSelectHandler(countrycode)"
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <input
                      type="number"
                      :disabled="isEdit"
                      v-model="input_number"
                      placeholder="Mobile Number"
                      class="mobile-number"
                      v-on:keydown="
                        (e) => {
                          if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                            e.preventDefault();
                          }
                        }
                      "
                    />
                    <span
                      @click="onEditPhoneNumber()"
                      class="edit-pen ml-2"
                    ></span>
                  </div>
                </div>
              </div>
              <!-- <div> -->
              <form class="row">
                <!--class="col-12 mb-4"-->
                <div v-if="isSearch" class="col-12">
                  <input
                    type="email"
                    v-model="email_address"
                    name="Email Address"
                    id="custEmailAdd"
                    placeholder="Email Address"
                    v-validate="'required|email'"
                    @focus="onClickInputHandler('showEmailKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('Email Address')">{{
                      errors.first("Email Address")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custEmailAdd'"
                    :onClickFun="() => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if(x == 'showEmailKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      })
                    }"
                  />
                <Vkeyboard
                  :inputName="'custEmailAdd'"
                  :showOrHide="keyboardsVisible.showEmailKeyboard"
                  :initialValue="email_address"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="() => {
                    keyboardsVisible.showEmailKeyboard = false;
                  }"
                  @changeKeyboardInput="email_address = $event"
                  @onClickClose="() => {
                    keyboardsVisible.showEmailKeyboard = false;
                  }"
                />
                </div>
                <!--class="col-6 mb-4"-->
                <div v-if="isSearch" class="col-6">
                  <input
                    type="text"
                    name="First Name"
                    v-model="first_name"
                    placeholder="First Name"
                    v-validate="'required'"
                    id="custfirstname"
                    @focus="onClickInputHandler('showFirstNameKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('First Name')">{{
                      errors.first("First Name")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custfirstname'"
                    :onClickFun="() => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if(x == 'showFirstNameKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      })
                    }"
                  />
                <Vkeyboard
                  :inputName="'custfirstname'"
                  :showOrHide="keyboardsVisible.showFirstNameKeyboard"
                  :initialValue="first_name"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="() => {
                    keyboardsVisible.showFirstNameKeyboard = false;
                  }"
                  @changeKeyboardInput="first_name = $event"
                  @onClickClose="() => {
                    keyboardsVisible.showFirstNameKeyboard = false;
                  }"
                />
                </div>
                <!--class="col-6 mb-4"-->
                <div v-if="isSearch" class="col-6">
                  <input
                    type="text"
                    name="Last Name"
                    v-validate="'required'"
                    v-model="last_name"
                    placeholder="Last name"
                     id="custlastname"
                     @focus="onClickInputHandler('showLastNameKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('Last Name')">{{
                      errors.first("Last Name")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custlastname'"
                    :onClickFun="() => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if(x == 'showLastNameKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      })
                    }"
                  />
                <Vkeyboard
                  :inputName="'custlastname'"
                  :showOrHide="keyboardsVisible.showLastNameKeyboard"
                  :initialValue="last_name"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="() => {
                    keyboardsVisible.showLastNameKeyboard = false;
                  }"
                  @changeKeyboardInput="last_name = $event"
                  @onClickClose="() => {
                    keyboardsVisible.showLastNameKeyboard = false;
                  }"
                />
                </div>

                <div v-if="isSearch" class="col-12">
                  <div class="d-flex pb-2">
                      <b-form-checkbox
                      class="j-checkbox"
                      v-model="is_loyality_subscribe"
                      unchecked-value="N"
                      value="Y"
                      
                    ></b-form-checkbox>
                    <span>{{ $t("subscribeloyality") }}</span>
                  </div>
                </div>
              </form>
              <!-- </div> -->

              <div class="col-11 mx-auto">
                <div class="row" :class="isEdit ? 'disbled-section' : ''">
                  <!-- <div class="col-4 mb-2" v-for="(loop , mobile) in 12" :key="mobile">
                  <button>{{mobile}}</button>-->

                  <div
                    class="col-4 mb-2"
                    v-for="(value, index) in phone_value"
                    :key="index"
                  >
                    <button
                      v-if="index == phone_value.length - 1"
                      v-on:click="onSliceNUmber()"
                      class="number"
                      :disabled="isEdit"
                    >
                      {{ value.name }}
                    </button>
                    <button
                      v-else-if="value.name != ''"
                      v-on:click="onClicknumber(index)"
                      class="number"
                      :disabled="isEdit"
                    >
                      {{ value.name }}
                    </button>
                    <button
                      v-else
                      @click.prevent.stop="onClickDelete"
                      class="number"
                      :disabled="isEdit"
                    >
                      C
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mx-auto">
          <div class>
            <button
              @click="$bvModal.hide('addcustmodal1')"
              class="btn-outline-blue-lg bg-transparent text-dark mr-1"
            >
              Cancel
            </button>
            <button
              v-on:click="onClickDelete()"
              class="btn-outline-blue-lg bg-transparent text-dark mr-1"
            >
              Clear
            </button>
            <button
              v-if="!isSearch"
              v-on:click="onSearch()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Search
            </button>
            <button
              v-else-if="isOldCustomer"
              v-on:click="onUpdateCustomerDetails()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Update
            </button>
            <button
              v-else
              v-on:click="onSaveDetails()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService.js";
import UserService from "@/services/UserService.js";
import PosService from "@/services/PosService.js";
import { mapState, mapGetters, mapActions } from "vuex";
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import { BASEURL } from "@/config/index.js";
import Nav from "@/NavHybrid";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { EventBus } from "@/main";

export default {
  props: {
    modalId: String,
    isRefundModal: {
      type: Boolean,
      default: false,
    },
    onHideModal: {
      type: Function,
      default: null,
    },
    getCallback: {
      type: Function,
      default: null,
    },
  },
  components: {
    Vkeyboard,
    VkeyboardFloat
  },
  data() {
    return {
       keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false,
      },
      Countries: [],
      SelectedCountryCode: "Code",
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" },
      ],
      searchCode: "",
      submitted: false,
    };
  },
  computed: {
    isRefundCustomer() {
      return this.isRefundModal;
    },
    getCustMobCode() {
      return this.$store.getters.getCustMobCode;
    },
    input_number: {
      get() {
        return this.$store.getters.customer_mobile_number;
      },
      set(value) {
        this.$store.dispatch("updateCustomerMobileNumber", value);
      },
    },
    first_name: {
      get() {
        return this.$store.getters.first_name;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "fname",
          value: value,
        });
      },
    },
    last_name: {
      get() {
        return this.$store.getters.last_name;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "lname",
          value: value,
        });
      },
    },
    email_address: {
      get() {
        return this.$store.getters.email_address;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "email",
          value: value,
        });
      },
    },
    is_loyality_subscribe: {
      get() {
        return this.$store.getters.is_loyality_subscribe;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "is_loyality_subscribe",
          value: value,
        });
      },
    },
    isOldCustomer() {
      return this.$store.getters.getIsOldCustomer;
    },
    isEdit() {
      return this.$store.getters.isEdit;
    },
    isSearch() {
      return this.$store.getters.isSearch;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    ...mapGetters([
      "getSelectedOffer",
      "CardNumber",
      "paymentModes",
      "usedCashCards",
      "cashCards",
      "getCashCardLogs",
      "getCustomers",
      "getShowCashCardLogsModal",
      //
      "SHOW_USER_INFO",
      //
      "SelectedFnbItemList",
      "selectedFnBItemsTotalPrice",
      "TotalAdditionalTaxes",
      "getIsSplitUsingLoyaltyCashCard",
      "getCustomerDetails",
      "cust_id",
    ]),
  },
  mounted() {

    this.getCountriesList();
    this.getCustomerList();
     EventBus.$on("callback_updateCustomerData", (data) => {
      console.log('callback_updateCustomerData CALLING', data);
      this.getCallback(data)
    });
  },
  beforeDestroy() {
    EventBus.$off("callback_updateCustomerData");
  },
  methods: {
    ...mapActions([
      "getCinemaDetails",
      "onChangePaymentValue",
      "setIsSplitUsingLoyaltyCashCard",
      "getCustomerList",
      "getCashCardTransactionLogs",
      "updateCashCardAmount",
      "fetchOffersList",
      "onSetSelectedOfferId",
    ]),
      onClickInputHandler(event) {
      if(Object.keys(this.keyboardsVisible).some((x) => this.keyboardsVisible[x] == true)) {
        Object.keys(this.keyboardsVisible).map((x) => {
          this.keyboardsVisible[x] = false;
        })
        this.keyboardsVisible[event] = true;
        this.$forceUpdate();
      }
    },
    handleOnHideModal() {
      if (this.isRefundCustomer) {
        console.log("this.isRefundCustomer", this.isRefundCustomer);
        this.onHideModal();
      }
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.Countries = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CodeListCopy;
      }
    },
    getCountriesList: function () {

      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CodeListCopy = data.Records;

            let defaultCon = data.Records.filter( c => {
              return c.country_mob_code == '966'
            })

            if(defaultCon.length > 0) {
              this.onSelectHandler(defaultCon[0])
            }
          }
          else {
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error :", error);
        });
    },
    onSelectHandler: function (value) {
      this.SelectedCountryCode = value.country_mob_code;
      this.$store.dispatch("updateCountryMobCode", value.country_mob_code);
    },
    onEditPhoneNumber: function () {
      this.$store.dispatch("onEditPhoneNumber");
    },
    onSliceNUmber: function () {
      if (!this.isEdit) {
        this.$store.dispatch("sliceNumber");
      }
    },
    onClicknumber: function (index) {
      this.input_number += this.phone_value[index].name;
    },
    onSaveDetails() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.getCustMobCode) {
            this.$toasted.show("Please Select Country Code.");
          } else if (this.input_number.length == 0) {
            this.$toasted.show("Please enter Mobile Number.");
          } else if (this.getCustMobCode && this.input_number.length > 0) {
            this.$store.dispatch("updateOnlyCustomerDetails", {
              first_name: this.first_name,
              last_name: this.last_name,
              mobile_number: this.input_number,
              is_loyality_subscribe: this.is_loyality_subscribe || 'N',
              cust_email: this.email_address,
              cust_id: this.cust_id,
              setOnlyUser: true,
              country_mob_code: this.getCustMobCode,
              hideModalIfFound: this.isRefundCustomer ? true : false,
              emitEvent: true,
            });
          }
          // this.first_name = "";
          // this.last_name = "";
          // this.input_number = "";
          // this.email_address = "";
          // this.isSearch = false;
        }
      });
    },
    onUpdateCustomerDetails() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.getCustMobCode) {
            this.$toasted.show("Please Select Country Code.");
          } else if (this.input_number.length == 0) {
            this.$toasted.show("Please enter Mobile Number.");
          } else if (this.getCustMobCode && this.input_number.length > 0) {
            this.$store.dispatch("updateCustomerData", {
              first_name: this.first_name,
              is_loyality_subscribe: this.is_loyality_subscribe || 'N',
              last_name: this.last_name,
              mobile_number: this.input_number,
              cust_email: this.email_address,
              cust_id: this.cust_id,
              country_mob_code: this.getCustMobCode,
              hideModalIfFound: this.isRefundCustomer ? true : false,
              emitEvent: true,
            });
          }
        }
      });
    },
    onSearch: function () {
      if (!this.getCustMobCode) {
        this.$toasted.show("Please Select Country Code.");
      } else if (this.input_number.length == 0) {
        this.$toasted.show("Please enter Mobile Number.");
      } else if (this.getCustMobCode && this.input_number.length > 0) {
        this.$store.dispatch("setUserDeatils", {
          sb_mobile_number: this.input_number,
          sb_booking_code:this.bookingDetails.sb_booking_code,
          onlySetUser: true
        });
      }
      // SendSmS Service
    },
    onClickDelete: function () {
      this.$store.dispatch("clearAllInput");
    },
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/AddCustomerDetailsPopup.vue